
"use client";

import { PIPTimer } from "@/components/timer";
import { Box } from "@mui/material";

export function PictureInPictureWindow() {

  return (
    <Box sx={{
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '16px',
    }}>
      <PIPTimer />
    </Box>
  );
}
